import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Slide
} from "@mui/material";
import type { SlideProps } from "@mui/material";
import type { TransitionProps } from "@mui/material/transitions";
import CloseIcon from "@mui/icons-material/Close";

interface ModalFormProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  maxWidth?: string | number;
  minWidth?: string | number;
  children: React.ReactNode;
  direction?: SlideProps["direction"];
}

const ModalForm: React.FC<ModalFormProps> = ({
  open,
  onClose,
  title,
  maxWidth = 600,
  minWidth = 320,
  children,
  direction = "left",
}) => {
  const Transition = React.useMemo(
    () =>
      React.forwardRef<unknown, TransitionProps & SlideProps>(
        function Transition(props, ref) {
          return (
            <Slide
              ref={ref}
              direction={direction}
              {...props}
            />
          );
        }
      ),
    [direction]
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      TransitionComponent={Transition}
      scroll="paper"
      PaperProps={{
        sx: {
          maxWidth: { xs: '95vw', sm: maxWidth, md: maxWidth },
          minWidth: { xs: '95vw', sm: minWidth, md: minWidth },
          borderRadius: 3,
          p: 0,
          bgcolor: "background.paper",
          m: { xs: 1, sm: 2 }, // margen para no pegar a los bordes
        },
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={3}
        pt={2}
        pb={1}
      >
        <DialogTitle
          sx={{ p: 0, fontWeight: 600, fontSize: 20, flex: 1 }}
        >
          {title}
        </DialogTitle>

        <IconButton onClick={onClose} size="small" sx={{ ml: 2 }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent
        dividers
        sx={{ px: 3, py: 2, maxHeight: "70vh", overflowY: "auto" }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default ModalForm;

